import { gql } from '@apollo/client';

export const GET_VIEWER = gql`
    query {
        viewer {
            id
            firstName
            lastName
            email
            lastLogin
            language
            showExplanationsByDefault
            sendEmailNotification
            isStaff
            canSwitchSupportUser
            grantableGroups
            permissions
            passwordEnabled
            dateJoined
            hasMfaDevice
            isChatEnabled

            customer {
                id
                name
                shortName
                timezone
                dataRetentionDays
                isAutomationDashboardEnabled
                isPropertyBillsEnabled
                isOrdersEnabled
                isOrderConfirmationsEnabled
                isRfqsEnabled
                isInvoicesEnabled
                isDeliveryNotesEnabled
                isListOfServicesEnabled
                isUniversalEnabled
                isAgentsEnabled
                isVoiceAgentsEnabled
                agentChatEnabled
                personalInboxAdminConsent {
                    isGranted
                    isUpToDate
                }
                sharedInboxAdminConsent {
                    isGranted
                    isUpToDate
                }
                isActive
                customizationKey
                customizationInfo
                createdAt

                mfaConfig {
                    isRequired
                }

                ssoConfig {
                    isRequired
                }
            }
            groups {
                id
                name
                memberCount
            }
            teams {
                id
                name
            }
        }
    }
`;
